import { useCallback, useEffect, useRef } from "react";

// Keeps --app-header-h in sync and, while a .sticky-table is scrolled internally,
// nudges the page so the table top (and its sticky header row) sits just below the app header.
export function useStickyTableAlign() {
  const ro = useRef(null);
  const hRef = useRef(130);

  useEffect(() => {
    const onScroll = (e) => {
      const el = e.target;
      if (!(el instanceof HTMLElement) || !el.classList.contains("sticky-table") || el.scrollTop <= 0) return;
      const gap = el.getBoundingClientRect().top - hRef.current - 8;
      if (gap < -1) window.scrollBy({ top: gap });
    };
    document.addEventListener("scroll", onScroll, true);
    return () => { document.removeEventListener("scroll", onScroll, true); if (ro.current) ro.current.disconnect(); };
  }, []);

  return useCallback((node) => {
    if (ro.current) ro.current.disconnect();
    if (!node) return;
    const set = () => {
      hRef.current = node.offsetHeight;
      document.documentElement.style.setProperty("--app-header-h", `${node.offsetHeight}px`);
    };
    set();
    ro.current = new ResizeObserver(set);
    ro.current.observe(node);
  }, []);
}
